export enum NoContentType {
  Team = 'team',
  Link = 'link',
}